/**
 * Service Template Constants
 */

/**
 * Authentication type constants
 * These should match the IDs from your backend authentication types lookup
 */
export const AUTH_TYPES = {
	OAUTH2_USERNAME_PASSWORD: 1,
	OAUTH2_CLIENT_CREDENTIALS: 2,
	// Backend ID 3 maps to the no-authentication provider: the runtime attaches nothing at
	// dispatch. Where a vendor needs credentials under this type, the admin supplies them as a
	// static custom header (e.g. Authorization: Basic <base64> / Bearer <token>) or in the
	// URL/body at setup time. Placeholders like [APIKEY] are admin-replaced, never substituted
	// by the runtime.
	NO_AUTH: 3,
	// Deprecated alias of NO_AUTH: the name is misleading (no API key is attached by the
	// runtime). Kept so existing templates keep compiling; use NO_AUTH in new templates.
	API_KEY: 3,
	JWT: 4
}

/**
 * Template categories for organizing templates
 */
export const TEMPLATE_CATEGORIES = {
	CRM: 'CRM',
	MARKETING: 'Marketing',
	ECOMMERCE: 'E-commerce',
	COMMUNICATION: 'Communication',
	PAYMENT: 'Payment',
	PRODUCTIVITY: 'Productivity',
	SUPPORT: 'Support',
	ANALYTICS: 'Analytics',
	CONTENT_MANAGEMENT: 'Content Management',
	CUSTOMER_ENGAGEMENT: 'Customer Engagement',
	NOTIFICATIONS: 'Notifications',
	GENERIC: 'Generic'
}
